export const commonKnowledge = [
"Steiger", 
"Hertog Jan",
"Grolsch",
"Emmer",
"School",
"Snapchat Games",
"Wijn",
"Quarantaine",
"Kabouter Lui",
"Koffie",
"Thee",
"6 Happy Hours",
"Airpods",
"Apple Watch",
"Nokia",
"Amerika",
"Pensioen",
"Hijskraan",
"Caravan",
"Jupiler", 
"Amsterdam", 
"Eindhoven",
"Twente",
"Kwal",
"Grey's Anatomy",
"Prison Break",
"Snollebollekes",
"Nutella",
"CDA",
"PVV",
"Hiroshima",
"Jan Smit",
"Doutzen Kroes",
"Humberto Tan",
"Gelredome",
"Microsoft Teams",
"Zwitsal",
"Familie Flodder",
"Heinz",
"Tirol",
"Sinterklaas",
"Klompen",
"Max Verstappen",
"Daniel Ricciardo",
"Kolonisten van Catan",
"Fortnite",
"Netflix",
"Wimbledon", 
"November", 
"Heilige Maagd Maria",
"Disney",
"Formule 1",
"Les Volgen",
"Pokemon Go",
"Woordenboek",
"Memes",
"Tortelduifjes",
"Alpen",
"Saus",
"Happy Meal",
"Taco's",
"Moffen",
"Sneeuw",
"Tinder",
"Ted Baker",
"Mexicano",
"Appelmoes",
"Puzzelen",
"Broodje Döner",
"Tomos",
"Kerstboom",
"Aliens",
"Pinkie",
"Sticker",
"Dikke Tampeloeres",
"The Grinch",
"Jip en Janken",
"Potvis",
"Floria",
"Amon",
"Tampon",
"Chocolade Melk",
"Doos",
"Spaarvarken",
"Rood",
"Varken",
"Blond",
"Wallen",
"Champignons",
"Roze Wolken",
"Hay Day",
"Stekelvarken",
"Ongemakkelijk",
"Knikkers",
"Whatsapp Web",
"Date",
"Zondag",
"Instagram",
"Rapper Sjors",
"Seks",
"Candy Crush",
"Aubergines",
"Bootycall",
"Sikje",
"Galgje",
"Bergen",
"Heuvels",
"Achterdochtig",
"Synoniem",
"Geheimzinnig",
"Gebarentaal",
"Babyface",
"Tabjes",
"Rechtermuisknop",
"Slapen",
"Wandelen",
"Puppy",
"Panda’s",
"Frikandellen",
"Telebankieren",
"Spelletjes",
"Stoer",
"Luiers",
"Pot",
"Kerstballen",
"Feminisme",
"Bullshit",
"Witte Kerst",
"Spotify", 
"Elon Musk",
"SpaceX",
"Tesla",
"BMW",
"Audi",
"Spyker",
"McLaren",
"Ferrari",
"Mercedes-Benz",
"Racing Point",
"Volkswagen",
"Tractor",
"Ploegen",
"Quad",
"Donald Trump",
"Barack Obama",
"Samsung",
"iOS",
"Android",
"Microsoft",
"Vanderlande",
"Bestek",
"Lepel",
"Zeshoek",
"Achthoek",
"Hardlopen",
"Zak Hooi",
"Among Us",
"Weerwolf",
"Zuipen",
"30 Seconds",
"Programmeren",
"Vulkaan",
"Queen",
"Bruce Springsteen",
"Snelle",
"Beatrix",
"Willem-Alexander",
"Barcelona",
"Miami",
"Golden Gate",
"Alcatraz",
"Dode zee",
"Ratchet & Clank",
"International",
"Pitbull",
"Jason Derulo",
"Yosemite",
"Karvan Cevitam",
"Klok",
"Horloge",
"David Bowie",
"David Hasselhof",
"Angela Merkel",
"Peter Pan",
"Jason Stathem",
"Rayman",
"iPhone",
"ABBA",
"Truckchauffeur",
"Calvin Harris",
"Eiffeltoren",
"Stokbrood",
"Frikandel",
"Avondklok",
"Corona",
"Call of Duty",
"DAF",
"Chrysler",
"Toetsenbord",
"Intel",
"Avicii",
"Bacardi",
"Mallorca",
"BZB",
"Tosti IJzer",
"Luxe Fauteuil",
"Airpods Max",
"Airpods Pro",
"Apple TV+",
"Virusscanner",
"Computervirus",
"Hackaanval",
"NASA",
"GPS",
"GLONASS",
"Galileo",
"Augmented Reality",
"Virtual Reality",
"Smirnoff",
"Zonnebril",
"Robert ten Brink",
"All You Need Is Love",
"Radio 538",
"QMusic",
"De Fabeltjeskrant",
"Yolanthe Cabeau",
"Jurk",
"Limonade",
"Wiskunde",
"Calculus",
"Sloffen",
"Dory",
"Nemo",
"Google Earth",
"Albert Einstein",
"Lieke Martens",
"Nelson Mandela",
"Stephen Hawking",
"Rico Verhoeven",
"Justin Bieber",
"Ariana Grande",
"Anne Frank",
"Leonardo di Caprio",
"Mark Zuckerberg",
"Martin Garrix",
"Will Smith",
"Gordon",
"George Clooney",
"Morgan Freeman",
"Ellen Degeneres",
"Walt Disney",
"Harry Houdini",
"Frank Sinatra",
"Britney Spears",
"Angelina Jolie",
"Brad Pitt",
"Meghan Markle",
"Alicia Keys",
"Dwayne Johnson",
"Ed Sheeran",
"Wham!",
"Boney M.",
"Bon Jovi",
"Marvin Gaye",
"John Travolta",
"Fleetwood Mac",
"Billy Joel",
"Amy Winehouse",
"Maroon 5",
"Eminem",
"Macklemore",
"Bryan Adams",
"Hypermobiel",
"Hamburgers",
"Kleppendeksel",
"Compressie",
"Aandrijf As",
"Ontsteking",
"Koppakking",
"Tuimelaar As",
"Krukas",
"3 Serie",
"Arriva",
"Limburg",
"Noord-Brabant",
"Zeeland",
"Noord-Holland",
"Zuid-Holland",
"Gelderland",
"Overijssel",
"Drenthe",
"Friesland",
"Groningen",
"Utrecht",
"Flevoland",
"Rijn",
"Maas",
"Waal",
"Turkije",
"Egypte",
"Marokko",
"Oostenrijk",
"Rusland",
"Moskou",
"Rasputin",
"Putin",
"Farao",
"Cleopatra",
"Mummy",
"Zuid-Afrika",
"Kaapstad",
"India",
"Mumbai",
"Sydney",
"Australië",
"Malta",
"George Russel",
"Louis Hamilton",
"Sebastian Vettel",
"Alexander Albon",
"Lance Stroll",
"Aston Martin",
"Alpha Tauri",
"Haas",
"Williams",
"Pirelli",
"Bambi",
"Frozen",
"Mexico Stad",
"Bulgarije",
"Sunny Beach",
"The Rolling Stones",
"Lee Towers",
"Maan",
"Suzan & Freek",
"Thomas Acda",
"Paul de Munnik",
"Dua Lipa",
"Lucas & Steve",
"Imagine Dragons",
"Jeangu Macrooy",
"The Weeknd",
"Atlantische Oceaan",
"Grote Oceaan",
"Atlantis",
"Indische Oceaan",
"Noord-Amerika",
"Zuid-Amerika",
"Europa",
"Azië",
"Oceanië",
"Eerste Wereldoorlog",
"Tweede Wereldoorlog",
"Koude Oorlog",
"Jeff Bezos",
"Larry Page",
"Louis Vuitton",
"Moët",
"Malibu",
"Bacardi Lemon 7Up",
"Jenga",
"New York Yankees",
"Versace",
"Hugo Boss",
"Nike",
"G-Star RAW",
"Gucci",
"Puma",
"Reebok",
"Prada",
"Superdry",
"Converse",
"Adidas",
"Calvin Klein",
"Levi's",
"The North Face",
"Zara",
"Vans",
"Scotch & Soda",
"New Balance",
"Balr.",
"Cast Iron",
"Chasin'",
"C&A",
"Crocs",
"DSquared2",
"Fila",
"Intersport",
"Lacoste",
"Marc O'Polo",
"McGregor",
"Stone Island",
];


export const everydayLife = [
"Boom",
"Automerk",
"Huisdeur",
"Deurklink",
"Toilet",
"Vaatwasser",
"Gootsteen",
"Prullenbak",
"Dreft",
"Gasfornuis",
"Stoomoven",
"Kitten",
"Vlaggetjes",
"Kinderfiets",
"Pizzaoven",
"Pizza",
"Macaroni",
"Aardappel",
"Wortel",
"Appel",
"Gazon",
"Lijnbus",
"Bakker",
"Politieagent",
"Heks",
"Vlogger",
"Blogger",
"Juffrouw",
"Voetballer",
"Moeder",
"Zwembad",
"Sportschool",
"Supermarkt",
"Spookhuis",
"Bibliotheek",
"Efteling",
"Pretpark",
"Ziekenhuis",
"Boomhut",
]; // end everydayLife

const toAdd = [

] // end Toadd